export const PACKAGE_VERSION = '1.7.0';
//# sourceMappingURL=constants.js.map